export enum CaseType {
    Notable,
    Other
}